var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFerroL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 4.5,
    fill: "white",
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7663 40.4397C25.7778 40.4397 26.5696 40.8659 27.1418 41.7183C27.7139 42.5651 28 43.7282 28 45.2075C28 46.7308 27.7037 47.9103 27.1111 48.7462C26.5236 49.5821 25.7216 50 24.705 50C23.6986 50 22.9093 49.6068 22.3372 48.8204H22.1762L21.7854 49.835H20V37H22.3372V39.986C22.3372 40.3655 22.3065 40.9731 22.2452 41.809H22.3372C22.8838 40.8962 23.6935 40.4397 24.7663 40.4397ZM24.0153 42.4524C23.4381 42.4524 23.0166 42.6449 22.751 43.0298C22.4853 43.4093 22.3474 44.0389 22.3372 44.9188V45.191C22.3372 46.1808 22.4725 46.8902 22.7433 47.3192C23.0192 47.7481 23.4534 47.9626 24.046 47.9626C24.5262 47.9626 24.9068 47.7261 25.1877 47.2532C25.4738 46.7747 25.6169 46.0819 25.6169 45.1745C25.6169 44.2671 25.4738 43.588 25.1877 43.1371C24.9017 42.6806 24.5109 42.4524 24.0153 42.4524Z",
    fill: "#005AE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2909 68.8277L59.8175 67.5185H59.7533C59.3414 68.0755 58.9161 68.4631 58.4774 68.6813C58.0441 68.8938 57.4771 69 56.7763 69C55.9151 69 55.2357 68.7359 54.7382 68.2076C54.2461 67.6793 54 66.9271 54 65.9509C54 64.9288 54.3317 64.1766 54.995 63.6942C55.6637 63.2061 56.6693 62.9363 58.012 62.8846L59.5687 62.8329V62.4109C59.5687 61.4347 59.1033 60.9466 58.1725 60.9466C57.4557 60.9466 56.6132 61.1792 55.6449 61.6443L54.8345 59.8699C55.8669 59.29 57.0117 59 58.2688 59C59.4724 59 60.3952 59.2814 61.0371 59.8441C61.679 60.4068 62 61.2624 62 62.4109V68.8277H60.2909ZM59.5687 64.3661L58.6219 64.4005C57.9104 64.4235 57.3808 64.5613 57.0331 64.814C56.6854 65.0666 56.5115 65.4513 56.5115 65.9681C56.5115 66.7089 56.9074 67.0792 57.6991 67.0792C58.2661 67.0792 58.7182 66.9041 59.0552 66.5538C59.3975 66.2036 59.5687 65.7384 59.5687 65.1585V64.3661Z",
    fill: "#008746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32V54.5H80",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerroL);
export default __webpack_public_path__ + "static/media/ferro_L.e7a21d602ce2377bbe253e13cba33df7.svg";
export { ForwardRef as ReactComponent };